export default {"src":"/_next/static/media/technical_issue.0f438709.svg","height":108,"width":147,"blurWidth":0,"blurHeight":0};